export default __webpack_public_path__ + "static/media/ic_harmony_one.02c2e3ba.svg";